import { HumorLevel } from './humor';
import { GPTModels, DEFAULT_MODEL } from './openaiModels';
import { VerbosityLevel } from './verbosity';

// Define the type for Preferences
interface Preferences {
    gptModel: GPTModels;
    verbosity: VerbosityLevel;
    humor: HumorLevel;
    language: string;
    // Remember to update isPreferences() in lib/utils.ts
}

const defaultPreferences: Preferences = {
    gptModel: DEFAULT_MODEL,
    verbosity: 3,
    humor: 2,
    language: 'English'
};

const defaultPreferencesRedisFormat: { [field: string]: string } = {
    gptModel: DEFAULT_MODEL,
    verbosity: "3",
    humor: "2",
    language: 'English'
};

export { defaultPreferences, defaultPreferencesRedisFormat };

export type { Preferences, VerbosityLevel };
